<era-security-member-list-ui [group]="group()"
                             [editEnabled]="editEnabled"
                             (toggleEditEvent)="toggleEditEvent()"
                             (addUserEvent)="addUserEvent()"
                             (addGroupEvent)="addGroupEvent()">
</era-security-member-list-ui>